<div class="row mt-2">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="vendorGrid"></action-toolbar-count>
                    <grid-export [grid]="gridVendors" [name]="'Purchased Material Vendors'"></grid-export>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <grid-column-group [grid]="vendorGrid"></grid-column-group>
                <wj-flex-grid
                    id="gridVendors"
                    #gridVendors
                    appAutoSize
                    [padding]="73"
                    [isReadOnly]="true"
                    (initialized)="vendorGrid.initialize(gridVendors)"
                    (destroy)="vendorGrid.destroy()"
                    [itemsSource]="vendorGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Vendor'" [binding]="'displayName'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Kind'" [binding]="'kind'" [width]="100" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="100" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Distinct items'" [binding]="'distinctDescriptions'" [width]="140" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="150" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
                </wj-flex-grid>
                <grid-selection-calculation [grid]="gridVendors"></grid-selection-calculation>
            </div>
        </div>
    </div>
</div>
